export default "https://cdn-static.gokick.com/assets/4beacdc4d8fafa1e61a7f98396d8ad8b9ab7b90c/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";